import React from "react"

import Layout2 from "../components/layout2"
import SEO from "../components/seo"

import InternLinks from "../components/internlinks";
import { FaCheck } from 'react-icons/fa';

const IndexPage = () => (
  <Layout2>
     <SEO title="Oral B Kids Frozen 3" description="Recension av Oral B Kids Frozen 3" keywords={[`Oral B`, `Vita tänder`, `Eltandborste`, `Tandblekning hemma`, `barntandborste`, `Oral B Kids Frozen 3`]}/>
     <section className="section-produkter">
       <article>
       <div className="prod-text">
          <h1>Kids Frozen 3+ år Eltandborste Box</h1>
         </div>
      </article>
      <article class="right">
        <img src="../frozen.jpg" alt="PRO 2 2000 White Sensi UltraThin Eltandborste"/>
        <aside>
          <h3 class="erbj-pris">279:-</h3>
          <h2>Kids Frozen 3+ år</h2>
          <p class="prod-beskrivning">
          </p>
          <a href="https://ion.lyko.com/t/t?a=1117786221&as=1480987224&t=2&tk=1&url=https://lyko.com/sv/oral-b/oral-b-kids-frozen-3--ar-eltandborstebox" target="_blank" rel="noopener noreferrer" class="btn btn-warning btn-width">Beställ här</a>
          <ul>
             <li><FaCheck className="li-icon" />Extra mjuka borststrån</li>
             <li><FaCheck className="li-icon" />Roligt med Disney MagicTimer app</li>
             <li><FaCheck className="li-icon" />Litet runt borsthuvud</li>
          </ul>
        </aside>
        <div className="prod-text"><h5>Kids eltandborstar</h5>
         <p>Oral-B Kids eltandborste för alla barn från 3 år, med snälla och vänliga motiv av Disneyfigurer låter små händer få kraft att göra riktigt rent. Den här laddningsbara eltandborsten för barn har extramjuka borststrån för unga munnar och kan noga rengöra flera ytor. Den är kompatibel med appen Disney MagicTimer från Oral-B.
             Mycket omtyckt bland barnen och smidigt med signalen som de väntar på, det gör det skoj och enkelt att borsta tänderna morgon som kväll. 
         </p>
        </div>
      </article>

       </section>
       {/* <section className="section-cards">
    <main>
    <h2 class="rubrik-tandblekning">Bästa tandblekningen hemma</h2>
       <Card />
       </main>
  </section> */}

  <section className="section-cards card-height">
  <main>
      <h2 class="internal-rubrik">Bästa tandblekningen hemma</h2>
    <InternLinks />
    </main>
  </section>
  </Layout2>
)

export default IndexPage
